import React from 'react';
import { GlobalSideNavigation } from '@atlassian/global-side-navigation';
import type { SidebarId } from '@atlassian/jira-route-types/src/Navigation.tsx';
import { getForYouConfig } from '../common/ui/getForYouConfig.tsx';

const forYouConfig = getForYouConfig();

type Props = {
	sidebarId: SidebarId;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function GSNForOtherSidebars({ sidebarId }: Props) {
	/*
	  TODO:
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
	*/

	return (
		<GlobalSideNavigation
			app="jira"
			customizationStore="local"
			forYou={forYouConfig}
			items={{}}
			testId="nav-platform-integration-sidebar.ui.jira-other-sidebars"
		/>
	);
}
